import React from 'react';
import { Image as BootstrapImage } from 'react-bootstrap';

const Image = ({ 
    src, 
    alt = '', 
    fluid = false, 
    rounded = false, 
    roundedCircle = false, 
    thumbnail = false, 
    width, 
    height, 
    isMobile = false, 
    isTablet = false, 
    isDesktop = false, 
    style, 
    className,
    onClick,
    ...props 
}) => {
    return (
        <BootstrapImage 
            src={src} 
            alt={alt} 
            fluid={fluid} 
            rounded={rounded} 
            roundedCircle={roundedCircle} 
            thumbnail={thumbnail}
            width={width}
            height={height}
            onClick={onClick}
            className={className} 
            style={style}
            {...props}
        />
    );
};

export default Image;

